import lottie from 'lottie-web';

const intersectionObserverAvailable = !!window.IntersectionObserver;

export default () => {
  document.querySelectorAll('.lottie').forEach(async (block, index) => {
    const jsonUrl = block.getAttribute('data-url');

    if (!jsonUrl) return;

    const animation = lottie.loadAnimation({
      container: block,
      renderer: 'svg',
      loop: false,
      autoplay: !intersectionObserverAvailable,
      path: jsonUrl,
    });

    if (!intersectionObserverAvailable) return;

    animation.addEventListener('data_ready', () => {
      const observer = new IntersectionObserver((entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        setTimeout(() => {
          animation.play();
        }, entries[0]?.target?.hasAttribute('data-no-delay') ? 50 : 400);
      }, { threshold: 0.1 });
      observer.observe(block);
    });
  });
};
